package ir.hosen.resume.screen

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.css.functions.invert
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import ir.hosen.resume.pages.Theme
import ir.hosen.resume.util.Res
import ir.hosen.resume.util.ScreenItem
import ir.hosen.resume.util.bps
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vw
import org.jetbrains.compose.web.dom.Img

private val SCREEN_ID = ScreenItem.ABOUT.id

@Composable
fun AboutScreen(modifier: Modifier = Modifier) {
    Box(
        modifier = modifier.id(SCREEN_ID),
        contentAlignment = Alignment.Center
    ) {
        Content(modifier = modifier.width(80.vw))
    }
}

@Composable
private fun Content(modifier: Modifier = Modifier) {
    Column(
        modifier = modifier,
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(32.px, Alignment.CenterVertically)
    ) {
        Row(verticalAlignment = Alignment.Top) {
            SpanText(
                modifier = Modifier.color(Theme.onBackgroundColor).fontFamily(Res.String.ROBOTO_CONDENSED)
                    .fontSize(32.bps()),
                text = "About me."
            )
            Img(
                src = "/portal_star.svg",
                attrs = Modifier.size(22.px)
                    .filter(invert(if (Theme.isDark) 0 else 1))
                    .toAttrs()
            )
        }

        SpanText(
            text = "Hossein is an Android developer who loves building modern apps and exploring new technologies.\n" +
                    "He's really passionate about Kotlin and enjoys using it to create apps beyond Android — maybe “Kotlin developer” fits him better!\n" +
                    "When he's not coding, you’ll probably find him playing guitar or riding his motorcycle — though most of the time, he's happiest in front of his computer.",
            modifier = Modifier
                .color(Colors.Gray)
                .fontFamily(Res.String.ROBOTO_REGULAR)
                .fontSize(18.bps())
                .textAlign(TextAlign.Center)
                .whiteSpace(WhiteSpace.PreLine)
        )
    }

}